export class PasswordHelper
{
    public static ValidatePassword(password: string | null): string[]
    {
        const errors: string[] = [];

        if (!password)
        {
            return [];
        }

        if (password.length < 8)
        {
            errors.push('Password must be at least 8 characters.');
        }
        if (!/[0-9]/.test(password))
        {
            errors.push('Password must contain at least one number.');
        }
        if (!/[A-Z]/.test(password))
        {
            errors.push('Password must contain at least one uppercase letter.');
        }
        if (!/[a-z]/.test(password))
        {
            errors.push('Password must contain at least one lowercase letter.');
        }
        if (!/[^a-zA-Z0-9]/.test(password))
        {
            errors.push('Password must contain at least one special character.');
        }

        return errors;
    }
}
